export default function getColor(color?: string, theme?: any) {
  switch (color) {
    case "primary":
      return theme?.palette.primary.main;
    default:
      return "white";
  }
}
